import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { getDataSession } from 'views/Utils/Common';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import { currency } from 'resources/utilities';
import { useUIUtils } from 'hooks/useUIUtils';

const AddEdit = ({ history, match }) => {
    const { id } = match.params;
    const isAddMode = !id;
    const { handleSubmit } = useForm();
    const [, setConceptoPago] = useState([]);
    const [documentosAdeudo, setDocumentosAdeudo] = useState([]);
    const [formasCobro, setFormasCobro] = useState([]);
    const { changeGlobalTitle } = useUIUtils()


    let [, setVxImporteCC] = useState([]);
    let [, setVxImporteCCDet] = useState({
         id: 0,
         documento_CC_Id: 0,
         fecha:null,
         cancelado:'N',
         aplicado: 'S',
         estatus:'T',
         tipo_Importe: 'P',
         documento_CC_Acr_Id: 0,
         importe: 0,
         impuesto:0,
         iva_Retenido: 0,
         isr_Retenido: 0,
         dscto_Pago:0,
         doc_Deuda: ""
    });

    let [model, setModel] = useState({
        id: 0,
        sucursal_Id: getDataSession('sucursal'),
        conceptos_Cobros_Id: 0,
        //condicion_Pago_Id: 0,
        cliente_Id: 0,
        venta_Id: 0,
        folio: "",
        concepto: "COBRO",
        naturaleza_Concepto: "R",
        descripcion: "",
        pctje_Dscto_Ppag: 0.000000,
        importe: 0.00,
        cancelado: "N",
        aplicado: "S",
        liquidado: "S",
        fecha: "",
        folio_Concepto: null,
        concepto_Cobro: "CONTADO",
        abonado: 0
    });

    
    useEffect(() => {
        async function getConceptoPago() {
            const response = await fetchConToken(`VxConceptosCobros/List?sucursal_Id=${getDataSession('sucursal')}`);
            setConceptoPago(response);
        }
        async function getFormasCobro() {
            const response = await fetchConToken(`VxFormaCobroCc/GetList?paginas=0&totalXpagina=1000&sucursal_Id=${getDataSession('sucursal')}`);
            setFormasCobro(response.data);
        }
        getConceptoPago();
        getFormasCobro();

        setModel(prev => ({
            ...prev,
            fecha: GetFecha(true)
        }));
        setVxImporteCCDet(prev => ({
            ...prev,
            fecha: GetFecha(true)
        }));
    }, []);

    function GetFecha(inicio) {
        var curr = new Date();
        return curr.toISOString().substring(0, 10);
    }
    
    React.useEffect(() => {
        changeGlobalTitle('Registrar Abono')
    },[changeGlobalTitle]);

   
    const loadClientes = async (query) => {
        console.log("loadClientes");
        if (getDataSession('sucursal') === '0') {
            Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
            return;
        }
        var resp = await fetchConToken(
            `Clientes/GetList?paginas=0&totalXpagina=50&busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}`
        );
        return resp.data;
    };
    
    function BuscarDocumentos(cliente_Id){
        if(!(cliente_Id > 0) )
            {
                Swal.fire("Info","Seleccione un cliente valido","info");
                return;
            }

        if (getDataSession('sucursal') === '0') {
            Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
            return;
        }
        fetchConToken(
            `VxDocumentosCc/GetList?paginas=0&totalXpagina=1000&sucursal_Id=${getDataSession('sucursal')}&liquidado=N&naturaleza_Concepto=C&cliente_Id=${cliente_Id}`
        ).then(resp=>{
            setDocumentosAdeudo(
                resp.data.map((item) => ({
                  ...item, 
                  abono: 0, 
                }))
              );
        });
        
        
    };


    // const loadDocumentosAdeudo = async (query) => {
    //     if(!(model.cliente_Id > 0) )
    //         {
    //             Swal.fire("Info","Seleccione un cliente valido","info");
    //             return;
    //         }
    //         if(model.fecha == null )
    //             {
    //                 Swal.fire("Info","Seleccione una fecha valida","info");
    //                 return;
    //             }


    //     if (getDataSession('sucursal') === '0') {
    //         Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
    //         return;
    //     }
    //     var resp = await fetchConToken(
    //         `VxDocumentosCc/GetList?paginas=0&totalXpagina=500&busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}&liquidado=N&naturaleza_Concepto=C&cliente_Id=${model.cliente_Id}`
    //     );
    //     return resp.data;
    // };


    function onSubmit() {
        if(!(model.cliente_Id > 0))
            {
                Swal.fire('Info', "Seleccione un agente valido", 'info');
                return;
            }

            if(!(model.forma_Cobro_Cc_Id > 0))
                {
                    Swal.fire('Info', "Seleccione una forma de cobro", 'info');
                    return;
                }
            
            model.Vx_Importe_Cobros  = [];

            documentosAdeudo.forEach((item) =>
                 {
                    if(item.abono > 0)
                    {
                        let vxImporteCCDetAux = {
                            documento_CC_Id: item.id,
                            cancelado:'N',
                            aplicado: 'S',
                            estatus:'T',
                            tipo_Importe: 'P',
                            documento_CC_Acr_Id: 0,
                            importe: item.abono,
                            impuesto:0,
                            iva_Retenido: 0,
                            isr_Retenido: 0,
                            dscto_Pago:0,
                            doc_Deuda: ""
                       };

                       model.Vx_Importe_Cobros.push(vxImporteCCDetAux);
                    }
                 }
              );


        return create(model);
    }
    function create(data) {
        return fetchConToken('VxCobros', data, 'POST')
            .then((response) => {
                if (response.hasOwnProperty('status')) {
                    Object.entries(response.errors).forEach(([ , value]) => {
                        Swal.fire('Error', value[0], 'error');
                    });
                    return false;
                    } else if (response.hasOwnProperty('codigo')) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return false;
                    }
                Swal.fire('Exito', 'Guardado', 'success');
                history.push('.');
            })
            .catch(alertService.error);
    }




    const handleInputChange = ({ target }) => {
        setModel({
            ...model,
            [target.name]: target.type === 'checkbox' ? target.checked === true : target.value
        });
    }

    function abonar(id){

           var restanteXAbonar = parseFloat(model.importe ?? 0) - parseFloat(model.abonado ?? 0);

            const updatedItems = documentosAdeudo.map((item) =>
              item.id === id ? { ...item, abono: (parseFloat((restanteXAbonar + item.abono) ?? 0) >= (parseFloat((item.importe-item.acreditado) ?? 0)) ? (parseFloat((item.importe-item.acreditado) ?? 0))  : parseFloat((restanteXAbonar + item.abono) ?? 0) ) } : { ...item, abono: parseFloat(item.abono ?? 0) ?? 0 }
            );
          
            setDocumentosAdeudo(updatedItems);

            const totalAbonado = updatedItems.reduce(
                (a, v) => a + parseFloat(v.abono ?? 0),
                0
              );
            
              // Actualiza el modelo con el nuevo total
              setModel({
                ...model,
                abonado: totalAbonado,
              });

    }

    // const handleInputChangeDetalle = ({ target }) => {

    //     setVxImporteCCDet({
    //         ...vxImporteCCDet,
    //         [target.name]: target.type === 'checkbox' ? target.checked === 'true' : target.value
    //     });
    // }

    const handleInputChangeDet= ({ target }) => {
     

        target.value = String(target.value).replace(/^0+/, '');
        target.value = target.value || 0;

        var restanteXAbonar = parseFloat(model.importe ?? 0) - parseFloat(model.abonado ?? 0);
        


        const updatedItems = documentosAdeudo.map((item) =>
            parseInt(item.id) === parseInt(target.id) ? { ...item, abono: (parseFloat(target.value ?? 0) <= (restanteXAbonar + model.abonado) ) ? (parseFloat(target.value ?? 0) <= (item.importe - item.acreditado) ? parseFloat(target.value ?? 0) : item.abono ): item.abono } : item
          );

          console.log(updatedItems)
          setDocumentosAdeudo(updatedItems);

          const totalAbonado = updatedItems.reduce(
            (a, v) => a + parseFloat(v.abono ?? 0),
            0
          );
        
          // Actualiza el modelo con el nuevo total
          setModel({
            ...model,
            abonado: totalAbonado,
          });
    }

    
    // function seleccionar(item) {
    //     setVxImporteCCDet({
    //         ...vxImporteCCDet,
    //         ["doc_Deuda"]:  (item.folio + ' ~ ' + item.concepto + ' ~ ' + item.fecha.substring(0,10) + ' ~ ' + currency(item.importe-item.acreditado)),
    //         ["documento_CC_Id"]: item?.id
    //     });
           
    //         setDeudaAux(item.importe-item.acreditado);
    //         closeModal();
    //  }

    // function guardarDetalle() {

    //     if(!(model.cliente_Id > 0) )
    //         {
    //             Swal.fire("Info","Seleccione un cliente valido","info");
    //             return;
    //         }
    //         if(model.fecha == null )
    //             {
    //                 Swal.fire("Info","Seleccione una fecha valida","info");
    //                 return;
    //             }

    //             if(vxImporteCCDet.importe <= 0)
    //             {
    //                 Swal.fire("Info","Escriba un importe valido","info");
    //                 return;
    //             }

    //             console.log(vxImporteCCDet.importe);
    //             console.log(deudaAux);
    //             if(vxImporteCCDet.importe > deudaAux)
    //                 {
    //                     Swal.fire("Revisar","El importe es mayor al adeudo","info");
    //                     return;
    //                 }

    //     if(vxImporteCC.filter(x=>x.fecha == vxImporteCCDet.fecha && x.documento_CC_Id == vxImporteCCDet.documento_CC_Id).length > 0)
    //     {
    //         Swal.fire("Info","Ya existe registrado el cobro del documento","info");
    //         return;
    //     }

    //     setVxImporteCC([...vxImporteCC,vxImporteCCDet]);
    //  }
     
    
    //  function eliminar(item) {
    //     const detallesNuevos = vxImporteCC.filter(x => !(parseInt(x.id) === parseInt(item.id) &&  parseInt(x.documento_CC_Id) === parseInt(item.documento_CC_Id)));
    //     setVxImporteCC(detallesNuevos);
    //  }

    return (
        <>
            <div className='container-fluid'>
                <form onSubmit={handleSubmit(onSubmit)} /*onReset=""*/>
                    <div className='mb-3'>
                        <div className='row' style={{ textAlign: 'left' }}>
                           
                        <div className='col-md-12' style={{ textAlign: 'left' }}>
                                <button className='btn btn-outline-success' type='submit'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='20'
                                        height='20'
                                        fill='currentColor'
                                        className='bi bi-check-lg'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                                    </svg>
                                    &nbsp; Guardar
                                </button>
                                &nbsp;
                                <Link
                                    to={isAddMode ? '.' : '..'}
                                    className='btn btn-outline-warning'
                                >
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='20'
                                        height='20'
                                        fill='currentColor'
                                        className='bi bi-reply'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                                    </svg>
                                    &nbsp; Regresar &nbsp;
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6' style={{ display: 'grid' }}>
                            <div className='card mb-3 '>
                                <div className='card-body text-start'>

                                    
                                    <label htmlFor='agente' className='form-label'>
                                        Cliente
                                    </label>
                                    <AsyncSelect
                                    className='react-select-placeholder'
                                        isClearable
                                        getOptionLabel={(option) =>
                                            option.rfc + '-' + option.nombre
                                        }
                                        getOptionValue={(option) => option.id}
                                        //defaultValue={initialObject.clave}
                                        loadOptions={loadClientes}
                                        onChange={(selectedItem) => {
                                                setModel({
                                                    ...model,
                                                    cliente_Id: selectedItem === 0 ? '' : selectedItem?.id
                                                });
                                                setVxImporteCC([]);
                                                BuscarDocumentos(selectedItem === 0 ? '' : selectedItem?.id);
                                        }}
                                    />
                                      
                                      
                                        <label htmlFor='fecha' className='form-label'>
                                                Fecha
                                        </label>
                                        <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                                                id="filled-number"
                                                type="date"
                                                name="fecha"
                                                className='form-control'
                                                value={model?.fecha?.substring(0, 10)}
                                                onChange={handleInputChange}
                                                InputLabelProps={{ shrink: true, }}
                                            />
                                

                                        <label htmlFor='Descripcion' className='form-label'>
                                                Descripcion
                                        </label>
                                        <textarea className='form-control' name='descripcion'  onChange={handleInputChange}>
                                                        {model.descripcion}
                                        </textarea>

                                    </div>
                               
                            </div>
                        </div>
                        <div className='col-md-6' style={{ display: 'grid' }}>
                            <div className='card mb-3 '>
                                <div className='card-body text-start'>

                                        <label htmlFor='forma_Cobro_Cc_Id' className='form-label'>
                                        Forma Cobro
                                        </label>  
                                        <select
                                                className='form-control'
                                                name='forma_Cobro_Cc_Id'
                                                value={model.forma_Cobro_Cc_Id}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option></option>
                                                {formasCobro?.map(c=>{
                                                    return  ( model.forma_Cobro_Cc_Id === c.id ?  <option value={c.id} selected>{c.nombre}</option> :  <option value={c.id}>{c.nombre}</option>);
                                                })}
                                        </select> 

                                        
                                    <label htmlFor='num_Cta_Pago' className='form-label'>
                                    Numero de Cuenta de Pago
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='num_Cta_Pago'
                                        value={model.num_Cta_Pago}
                                        onChange={handleInputChange}
                                    />  

                                    
                                <label htmlFor='referencia' className='form-label'>
                                    Referencia
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='referencia'
                                        value={model.referencia}
                                        onChange={handleInputChange}
                                    />  
                   
                                
  
                                    </div>
                               
                            </div>
                        </div>
                        <div className='col-md-4'>
                                <label htmlFor='Importe' className='form-label'>
                                    Importe
                                </label>
                                <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                                                id="filled-number"
                                                type="number"
                                                name="importe"
                                                className='form-control'
                                                value={model.importe}
                                                onChange={handleInputChange}
                                                InputLabelProps={{ shrink: true, }}
                                            />
                        </div>
                        <div className='col-md-12'>
                            {/*<div className='card mb-3'>
                                <div className='col-md-12 row'>
                                <div className='col-md-2'>
                                        <label htmlFor='fecha' className='form-label'>
                                                Fecha
                                        </label>
                                        <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                                                id="filled-number"
                                                type="date"
                                                name="fecha"
                                                value={vxImporteCCDet.fecha?.substring(0, 10) || GetFecha(true)}
                                                onChange={handleInputChangeDetalle}
                                                InputLabelProps={{ shrink: true, }}
                                            />
                                </div>
                                <div className='col-md-2'>
                                    <label htmlFor='importe' className='form-label'>
                                         Importe
                                    </label>
                                    <input
                                        type='number'
                                        className='form-control'
                                        name='importe'
                                        required={true}
                                        maxLength={100}
                                        value={vxImporteCCDet.importe}
                                        onChange={handleInputChangeDetalle}
                                    />     
                                </div>
                                <div className='col-md-4'>
                                <label>Documento:</label>
                                    <label>{vxImporteCCDet.doc_Deuda}</label>
                                </div>

                              
                                <div className='col-md-2'>
                                    <div className='espacio30px' />
                                    <button
                                                    className='btn btn-outline-success'
                                                    onClick={(e) => {
                                                        BuscarDocumentos()
                                                    }}
                                                    type='button'
                                                >
                                                    &nbsp; Buscar Documentos
                                        </button>
                                </div>
                                <div className='col-md-2 '>
                                    <div className='espacio30px' />
                                        <button
                                                    className='btn btn-outline-success'
                                                    onClick={(e) => {
                                                        guardarDetalle()
                                                    }}
                                                    type='button'
                                                >
                                                    &nbsp; Agregar Abono
                                        </button>
                                </div>
                                </div>
                            </div>*/}
               
                            {/*<div className='card-body text-start'>
                            <div style={{ overflowX: 'auto' }}>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-text'>Fecha Pago</th>
                                                        <th className='text-left'>Doc. Adeudo</th>
                                                        <th className='text-left'>Importe Abono</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {vxImporteCC?.map((item) => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td className='text-left'>
                                                                    {item.fecha?.substring(0, 10)}
                                                                </td>
                                                                <td className='text-left'>
                                                                    {item.doc_Deuda}
                                                                </td>
                                                                <td className='text-left'>
                                                                    {currency(item.importe)}
                                                                </td>
                                                                <td style={{ width: "50px"}} >
                                                                    <button
                                                                        type='button'
                                                                        className='btn  mr-1'
                                                                        onClick={() =>
                                                                            eliminar(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        <svg
                                                                            xmlns='http://www.w3.org/2000/svg'
                                                                            width='25'
                                                                            height='25'
                                                                            fill='currentColor'
                                                                            className='bi bi-x-circle-fill'
                                                                            viewBox='0 0 16 16'
                                                                        >
                                                                            <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z' />
                                                                        </svg>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                
                                                </tbody>
                                            </table>
                                        </div>
                            </div>*/}
                        </div>
                    </div>
                </form>
                <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-center'>Documento</th>
                                                        <th className='text-center'>Folio</th>
                                                        <th className='text-center'>Fecha</th>
                                                        <th className='text-center'>Vencimiento</th>
                                                        <th className='text-center'>Saldo</th>
                                                        <th className='text-center'>Acreditar</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {documentosAdeudo?.map((item) => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td className='text-left'>
                                                                    {item.concepto}
                                                                </td>
                                                                <td className='text-left'>
                                                                    {item.folio}
                                                                </td>
                                                                <td className='text-center'>
                                                                    {item.fecha?.substring(0, 10)}
                                                                </td>
                                                                <td className='text-center'>
                                                                    {item.fecha_Registro?.substring(0, 10)}
                                                                </td>
                                                                <td className='text-right'>
                                                                    {currency(item.importe-item.acreditado)}
                                                                </td>
                                                                <td className='text-right'>
                                                                    <input 
                                                                    id= {item.id}
                                                                    type='number' 
                                                                    name = 'abono'
                                                                    className='form-control' 
                                                                    style={{maxWidth: "150px"}} 
                                                                    value={parseFloat(String(item.abono).replace(/^0+/, "") || "0")}
                                                                    onChange={handleInputChangeDet}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <button
                                                                                type='button'
                                                                                className='btn btn-success'
                                                                                onClick={() => abonar(item.id)}
                                                                            >
                                                                        Abonar
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                
                                                </tbody>
                </table>
                <div className='row'>
                    <div className='col-md-4'>
                        <label>Importe Cobro:</label> <strong>{currency(model.importe)}</strong>
                    </div>
                    <div className='col-md-4'>
                        <label>Saldo Total:</label> <strong>{currency(documentosAdeudo.reduce((a, v) => (a = a +  (v.importe - v.acreditado)), 0))}</strong>
                    </div>
                    <div className='col-md-4'>
                        <label>Total Acreditado:</label> <strong>{currency(documentosAdeudo.reduce((a, v) => a + parseFloat(v.abono ?? 0),0))}</strong>
                    </div>

                </div>
                <br/>
                <br/>
            </div>
            
            
        
        </>
    );
};

export { AddEdit };
